export default "__VITE_ASSET__8157c7da__"